module.exports = __webpack_public_path__ + "img/103.0563167a.png";